module.exports = __webpack_public_path__ + "img/templates.268560de.svg";